import React, { useEffect } from "react";
import SEO from "./SEO";
import Navbar from "./Navbar";
import FirstTimeBuyer from "./Homebuyer";
import FooterMain from "./FooterMain";
import { useEnquiryModal } from "./EnquiryModal";

const PopularAreas = () => {
    const { openModal } = useEnquiryModal();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <SEO
                title="Best Family Neighborhoods in Dubai & Areas"
                description="Neighborhood guides: Dubai Marina, Business Bay, Palm Jumeirah and Sharjah — best family neighborhoods and affordable housing options."
                canonical="http://localhost:3000/areas"
                keywords="best family neighborhoods dubai, affordable housing options sharjah families, villas close to ibn battuta mall"
            />
            <Navbar />
            <div id="areas" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
                <div className="flex flex-col sm:flex-row justify-between items-center md:mb-6 mb-4">
                    <h2 className="md:text-4xl text-2xl text-black font-bold">Popular Areas in Dubai</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    {/* Large Left Card */}
                    <div onClick={openModal} className="md:col-span-2">
                        <div className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                            <img
                                src="./Assets/area1.webp"
                                alt="Masterplan"
                                className="w-full h-48 md:h-80 lg:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                            <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                                <h3 className="text-lg font-bold">Palm Jebel Ali</h3>
                                <p className="text-sm opacity-90">Price from 19,400,000 AED</p>
                            </div>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div onClick={openModal} className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area2.jpg"
                            alt="Dubai Marina"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Dubai Marina</h3>
                            <p className="text-sm opacity-90">Price from 650,000 AED</p>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div onClick={openModal} className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area3.jpg"
                            alt="Downtown Dubai"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Downtown Dubai</h3>
                            <p className="text-sm opacity-90">Price from 1,050,000 AED</p>
                        </div>
                    </div>
                </div>

                <div onClick={openModal} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    <div className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area4.jpg"
                            alt="Dubai Marina"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Palm Jumeirah</h3>
                            <p className="text-sm opacity-90">Price from 750,000 AED</p>
                        </div>
                    </div>
                    <div className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area5.webp"
                            alt="Dubai Marina"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Business Bay</h3>
                            <p className="text-sm opacity-90">Price from 699,000 AED</p>
                        </div>
                    </div>
                    <div className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area6.jpg"
                            alt="Dubai Marina"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Dubai Hills Estate</h3>
                            <p className="text-sm opacity-90">Price from 1,450,000 AED</p>
                        </div>
                    </div>
                    <div className="relative overflow-hidden rounded-xl group cursor-pointer h-full">
                        <img
                            src="./Assets/area7.jpg"
                            alt="Dubai Marina"
                            className="w-full h-48 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        <div className="absolute bottom-4 left-4 text-white transition-all duration-500 group-hover:bottom-6">
                            <h3 className="text-lg font-bold">Emaar Beachfront</h3>
                            <p className="text-sm opacity-90">Price from 1,500,000 AED</p>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>
            <FirstTimeBuyer />
            {/* <div className="border-t border-[#003153]"></div>
            <Footer /> */}
            <FooterMain />
        </>
    );
};

export default PopularAreas;
